var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShortsSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.78767 10.0631C2.48165 9.88187 2.20993 9.72367 1.92633 9.56482C1.12171 9.10079 0.510327 8.42122 0.351381 7.50437C0.102079 6.03252 0.328957 4.78675 1.89204 3.84749C3.86402 2.66961 5.85777 1.54842 7.85218 0.404822C9.80109 -0.704502 12.3726 0.586084 12.6674 2.8166C12.8712 4.17508 12.2031 5.51114 10.9909 6.1683C10.7304 6.31529 10.4586 6.47414 10.1638 6.6554C10.4586 6.82546 10.7073 6.98365 10.9684 7.13064C13.042 8.29665 13.3137 11.0479 11.4895 12.5652C11.1267 12.8598 10.6967 13.0747 10.2885 13.3127C8.57766 14.3093 6.85564 15.3052 5.13361 16.2788C3.53624 17.1396 1.54249 16.5279 0.681144 14.9315C-0.134691 13.4142 0.363912 11.535 1.81421 10.6175C2.14266 10.4481 2.44868 10.2668 2.78833 10.0625L2.78767 10.0631Z",
    fill: "#FD0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88354 10.8449L9.16651 8.3646L4.88354 5.89746V10.8449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShortsSmall);
export default __webpack_public_path__ + "static/media/shorts-small.102bc3ac105d4613746471742bb2c60e.svg";
export { ForwardRef as ReactComponent };